import React, { useEffect, useState } from "react";

import UserService from "app/services/userService";

import Dash from "..";
import ModalBoost from "./ModalBoost";

interface BoostListPorps {
  created: string;
  nb_boost: number;
  paiement_proof: string;

  price: number;

  status: number;
}

const AccountBoost = () => {
  const [boostList, setBoostList] = useState<BoostListPorps[]>([]);
  const [showModalBoost, setShowModalBoost] = React.useState(false);
  useEffect(() => {
    UserService.getBoostList().then((data) => {
      setBoostList(data);
    });
  }, [showModalBoost]);

  return (
    <div>
      <Dash>
        <div className="bg-white p-8 rounded-md w-full">
          <div className=" flex items-center justify-between pb-6">
            <div></div>
            <div className="flex items-center justify-between">
              <div className="lg:ml-40 ml-10 space-x-8">
                <button
                  onClick={() => setShowModalBoost(true)}
                  className="bg-indigo-600 px-4 py-2 rounded-md text-white font-semibold tracking-wide cursor-pointer"
                >
                  Achter des boosts
                </button>
              </div>
            </div>
          </div>
          <div>
            <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
              <div className="inline-block min-w-full shadow rounded-lg overflow-hidden">
                <table className="min-w-full leading-normal">
                  <thead>
                    <tr>
                      <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Quantité
                      </th>

                      <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Prix
                      </th>
                      <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Créé le
                      </th>
                      <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {boostList.map((b, i) => {
                      let status = "En attante";
                      let color = "bg-blue-400";
                      if (b.status === 1) {
                        color = "bg-green-400";
                        status = "Valider";
                      }

                      if (b.status === 2) {
                        color = "bg-red-400";
                        status = "Non reçu";
                      }

                      if (b.status === 3) {
                        status = "Invalide";
                        color = "bg-red-400";
                      }

                      return (
                        <tr key={i}>
                          <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <div className="flex items-center">
                              {b.nb_boost}
                            </div>
                          </td>

                          <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <p className="text-gray-900 whitespace-no-wrap">
                              {b.price}
                            </p>
                          </td>
                          <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <p className="text-gray-900 whitespace-no-wrap">
                              {b.created}
                            </p>
                          </td>
                          <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <span className="relative  inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
                              <span
                                aria-hidden
                                className={`absolute inset-0 ${color} rounded-full`}
                              ></span>
                              <span className="relative text-white">
                                {status}
                              </span>
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <ModalBoost
            show={showModalBoost}
            onCloseModalBoost={() => setShowModalBoost(false)}
          />
        </div>
      </Dash>
    </div>
  );
};

export default AccountBoost;
